import script from "./PokerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PokerItem.vue?vue&type=script&setup=true&lang=js"

import "./PokerItem.vue?vue&type=style&index=0&id=3bfebdfb&lang=css"

const __exports__ = script;

export default __exports__